import React from "react";
import "./ClientsOverview.css";

export const ClientCardSkeleton = ({ cards = 12 }) => {
  return (
    <>
      <style>{`
        @keyframes shimmer {
          0% { background-position: -400px 0; }
          100% { background-position: 400px 0; }
        }
        .sk-block {
          background: linear-gradient(90deg, #ececec 25%, #f5f5f5 50%, #ececec 75%);
          background-size: 800px 100%;
          animation: shimmer 1.4s ease-in-out infinite;
          border-radius: 6px;
        }
      `}</style>
      {Array.from({ length: cards }).map((_, index) => (
        <div key={`client-skeleton-${index}`} className="ls-box" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ width: "100%", display: "flex", justifyContent: "center", paddingBottom: "20px" }}>
            <div
              className="sk-block"
              style={{ width: "100%", maxWidth: "180px", height: "100px", borderRadius: "8px", animationDelay: `${(index % 5) * 0.08}s` }}
            />
          </div>
          <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <div
              className="sk-block"
              style={{ width: "65%", height: "18px", borderRadius: "4px", animationDelay: `${(index % 5) * 0.08}s` }}
            />
          </div>
        </div>
      ))}
    </>
  );
};
